var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AudioWrapper',{ref:_vm.refName,attrs:{"src":_vm.link.src},on:{"error":_vm.errorHandler},nativeOn:{"ended":function($event){return _vm.ended.apply(null, arguments)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }